import React, { useEffect, useState } from "react"
import __t from "../../../lib/traduzioni"
import BSSErrorBar from "../../BSSErrorBar"
import { WaitKC } from "../../Wrapper"
import useSWRImmutable from 'swr/immutable';
import useBSSLogger from "../../../hooks/useBSSLogger";
import { Box, Divider, Paper, Stack } from "@mui/material"
import { info, orderStates, usersOrders } from "../../../api/testataordine"
import { NoPreviousData } from "../../preventivo/Preventivo"
import { useAsyncFn, useDeepCompareEffect, useSearchParam } from "react-use"
import FlashMessages from "../../FlashMessages"
import { pageToSkip, skipToPage } from "../../paginator/utils"
import { defaultStatoMenu } from "./utils"
import DettaglioOrdine from "./dettaglio/DettaglioOrdine"
import AzioniOrdine from "./AzioniOrdine"
import StoricoOrdiniGrid from "./viste/StoricoOrdiniGrid"
import StoricoOrdiniMasonry from "./viste/StoricoOrdiniMasonry"
import FiltriOrdini, { almenoUnFiltro } from "./filtri/FiltriOrdini"
import { Skeleton } from "@mui/material"
import DefaultLoadingComponent from "../../form/DefaultLoadingComponent";
import DefaultErrorComponent from "../../form/DefaultErrorComponent";

const {logger} = useBSSLogger();


const pageSize = 100;



const StoricoOrdini = ({children}) => {    
    

    return (
        <>
            <WaitKC>
                <_StoricoOrdini />
            </WaitKC>
            <BSSErrorBar />
        </>
    )
}

const filtriOrdiniDefault = {
    dadata: null, 
    adata: null, 
    term: null, 
    stati: null, 
    campiRicerca: null,
    operatore: "eq", //operatore di comparazione (eq|ne|lt|lte|gt|gte)
    totaleordine: null,
    fatturato: null,
    tipispedizione: null,
}

const _StoricoOrdini = () => {
    
    const [dialogDuplica, setDialogDuplica] = useState({open: false, ordine: null})
    const codiceOrdine = useSearchParam("ordine")
    const [filtri, setFiltri] = useState({skip: 0, filtriRicerca: filtriOrdiniDefault});   
    const [statoMenu, setStatoMenu] = useState({...defaultStatoMenu})     

    const initialData = async () => {
        const {data} = await info();
        const {stati, tipispedizione, campiRicerca} = data;      
                                
        return {
            stati,
            tipispedizione,
            campiRicerca,
        }
    }    
    
    const {data, error} = useSWRImmutable(`/api/statiordine`, initialData, {
        onErrorRetry: (error, key, config, revalidate) => {
            return             
        }
    })
    
    if(!error && !data){
        return (<DefaultLoadingComponent />) 
    } 

    if(error){
        logger.debug("errore", error)
        return <DefaultErrorComponent {...{error}} />
    } 

    const stati = data.stati.reduce((obj, stato) => ({...obj, [stato.id]: stato}), {});
    const campiRicerca = data.campiRicerca;
    const tipispedizione = data.tipispedizione;
    
    return (
        <Box w={1}>

            <Box p={2} >     
                <Paper sx={{mb: 2}}>
                    <FlashMessages />                   
                </Paper>      

                {codiceOrdine === null ? (
                    <>
                        <Stack>
                            <Box>
                                <FiltriOrdini {...{filtri, setFiltri, stati, tipispedizione, campiRicerca}} />
                            </Box>

                            <__StoricoOrdini {...{filtri, setFiltri, stati, campiRicerca, tipispedizione, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}} />
                            
                        </Stack>
                    </>
                ) : (
                    <DettaglioOrdine codiceOrdine={codiceOrdine} {...{stati, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}} />   
                )}
                <AzioniOrdine {...{stati, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}} />       
                
            </Box>

        </Box>
                                    
    )
}

const __StoricoOrdini = ({filtri, setFiltri, stati, campiRicerca, tipispedizione, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}) => {

    const [{loading, error, value: ordini}, caricaOrdini] = useAsyncFn(async ({filtri, pageSize}) => {
        
        const {skip, filtriRicerca} = filtri;
        const page = skipToPage(skip, pageSize);

        
        const ordini = await usersOrders({
            pageSize,
            take: pageSize,
            skip: skip, 
            page,
            filtriRicerca: JSON.stringify({
                ...filtriRicerca
            })            
        });       
        
        logger.debug("ordini", ordini, page, skip)

        return ordini;
    })

    
    useDeepCompareEffect(() => {
        logger.debug("ricarico gli ordini useEffect", filtri, pageSize)
        caricaOrdini({filtri, pageSize});
    }, [filtri, pageSize])

    if(loading || !error && !ordini){
        return (
            <Skeleton variant="rectangular" animation={"wave"}
                sx={{w: 1, height: "100px"}}
            />
        )
    }

    if(error){
        logger.debug("errore", error)
        return <DefaultErrorComponent {...{error}} />
    } 

    let {total} = ordini;
    const npagine = Math.ceil(total / pageSize);

    const listaOrdini = ordini.results;
    const page = skipToPage(filtri.skip, pageSize);
    const cambiaPagina = (e, newPage) => {
        logger.debug("cambio pagina", newPage, pageToSkip(newPage, pageSize))
        setFiltri({
            ...filtri,
            skip: pageToSkip(newPage, pageSize),
        })
    }

    const propsListe = {listaOrdini, stati, tipispedizione, campiRicerca, page, npagine, cambiaPagina, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica};


    return (listaOrdini.length > 0) ? (
            <Box>
                <Box sx={{display: ["none", "none", "none", "block"]}}>
                    <StoricoOrdiniGrid {...propsListe} />          
                </Box>      
                <Box sx={{display: ["block", "block", "block", "none"]}}>
                    <StoricoOrdiniMasonry {...propsListe} />          
                </Box>                              
            </Box>
        ) : !almenoUnFiltro(filtri) ? (
                <>
                    <NoPreviousData message={__t("nessunordine")} />
                </>
            ) : (
                <>
                    <NoPreviousData message={__t("nessunrisultatodafiltri")} noButton />
                </>
            )
}

export default StoricoOrdini
export {filtriOrdiniDefault}